module.exports = __webpack_public_path__ + "static/media/noimage.1260c83f.jpg";